import { MaxIcon, TelegramIcon, WhatsappIcon } from "@/components/icons"

// The company's own chats, as the public site (prostor) links them.
export const MESSENGERS = [
  { name: "MAX", href: "https://max.ru/id7841080825_bot", Icon: MaxIcon },
  { name: "Telegram", href: "https://t.me/Prostor_self_storage", Icon: TelegramIcon },
  { name: "WhatsApp", href: "https://wa.me/78122070007", Icon: WhatsappIcon },
] as const
